(function () {
    window.addEventListener('load', function () {
        const footer = {
            dom: {
                tab: 'body footer .footer-tabs .tab-title',
                menu: 'body footer > nav',
                body: 'body',
            },
            switchFooter(index) {
                let tabActive = document.querySelector(this.dom.tab + '.active');
                let menuActive = document.querySelector(this.dom.menu + '.active');
                if (tabActive) tabActive.classList.remove('active');
                if (menuActive) menuActive.classList.remove('active');

                let tabToShow = this.tabItems[index];
                let menuToShow = this.menuItems[index];

                tabToShow.classList.add('active');
                menuToShow.classList.add('active');
            },
            setupEventListeners() {
                document.querySelectorAll(this.dom.tab).forEach((item, index) => {
                    item.addEventListener('click', () => {
                        this.switchFooter(index);
                    });
                });
            },
            init() {
                this.tabItems = Array.from(document.querySelectorAll(this.dom.tab));
                this.menuItems = Array.from(document.querySelectorAll(this.dom.menu));

                /* Checks in what section we are in and changes the footer active tab if it's different than the default. */
                let bodyClass = document.querySelector(this.dom.body).className;

                if (bodyClass && bodyClass.includes('professionals')) {
                    let profTab = this.tabItems.find(item => {
                        let classList = Array.from(item.classList);

                        return classList.includes('professionals');
                    });

                    let index = this.tabItems.indexOf(profTab);
                    if (index !== -1) this.switchFooter(index);
                }

                this.setupEventListeners();
            }
        }

        footer.init();
    });
})();
